import React, { useRef } from 'react';
import { systemCode, xs_languageCode } from '../..';
import { getCheckbetPage, scanTicketId } from '../../data/utils';
import { getLabel } from '../../data/labels';

function CheckbetTicket(props) {
	const inputRef = useRef(null);
	
	function submit(){
        const ticketId = inputRef.current.value.trim().replaceAll("{{-}}", "");
        if (ticketId && ticketId.length > 0) {
        	if(window.appConfig?.TERMINAL_AGENCY && window.setRetailInfoTicketId){
        		window.setRetailInfoTicketId(ticketId);
        	}
        	else{
	            const checkbetPage = getCheckbetPage(false);
	            const url = `${window.XSPORT_PUBLIC_URL}${checkbetPage}?ticket=${ticketId}&system_code=${systemCode}&language=${xs_languageCode}`;
	            window.open(url, '', 'width=400,height=800');        	
        	}
        	inputRef.current.value = "";
        }
	}	
	function handleKeyPress(evt){
		const keyCode = evt.which || evt.keyCode;
		if(keyCode === 13){
			submit();
		}
	}
	function getTicketId(){
		const scanned = scanTicketId(inputRef.current.value);
		//setReprinted(scanned.isReprint);
		return scanned.id;
	}
	function handleChange(){
		inputRef.current.value = getTicketId();
	}
    return (
        <div className="bg-bianco bordo-tondo margine-giu widget-betslip">
            <div className="titolo-widget-stampa maiuscolo bg-nero bianco bordo-tondo-alto-sx bordo-tondo-alto-dx">
                <span><i className="fas fa-circle"></i> {getLabel('prematch_page.widget.checkbet.title')}</span>
            </div>
            <div className="contenuto-widget bordato-widget padding-orizzontale padding-verticale">
                <div className="input-widget">
                    <input ref={inputRef} onChange={handleChange} onKeyPress={handleKeyPress} className="input-personalizzato" type="text" id="checkbet-input" placeholder={getLabel('prematch_page.widget.checkbet.ticket_id')} />
                    <a className="bottone bg-colore-1 bianco" onClick={submit}>{getLabel('prematch_page.widget.checkbet.check_bet')}</a>
                </div>
            </div>
        </div>
    )
}

export default CheckbetTicket;